import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  countries: [],
  operator_set: null,
  fx_rate: null,
  loading_operator: false,
};

const slice = createSlice({
  name: "sendtopup",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
      state.loading_operator = true;
    },
    stopLoading(state) {
      state.isLoading = false;
      state.loading_operator = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET COUNTRIES
    getCountriesSuccess(state, action) {
      state.loading_operator = false;
      state.countries = action.payload;
    },

    // GET OPERATOR
    getOperatorSuccess(state, action) {
      state.loading_operator = false;
      state.operator_set = action.payload;
    },

    // GET FX RATE
    getFxRateSuccess(state, action) {
      state.loading_operator = false;
      state.fx_rate = action.payload;
    },

    // RESET STATE
    resetState() {
      return initialState;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  resetState,
  getOperatorSuccess,
  getFxRateSuccess,
  startLoading,
  stopLoading,
} = slice.actions;

// ----------------------------------------------------------------------

export function getAllCountries() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/v1/dashboard-agent/reloadly/countries/`
      );
      dispatch(slice.actions.getCountriesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function autoDetectOperator(phone, countryCode) {
  const response = await axios.post(
    `/api/v1/dashboard-agent/reloadly/auto-detect-operator/`,
    {
      phone,
      country_code: countryCode,
    }
  );
  return response.data;
}

export async function fxRate(amount, operatorId) {
  const response = await axios.post(
    `/api/v1/dashboard-agent/reloadly/auto-fx-rate/`,
    {
      amount,
      operatorId,
    }
  );
  return response.data;
}

export async function sendTopUp(data) {
  const response = await axios.post(
    `/api/v1/dashboard-agent/create-ticket`,
    data
  );
  return response.data;
}
